const SET_TAB = 'SET_TAB';

const setTab = activeTab => ({
  type: SET_TAB,
  payload: {
    activeTab
  }
});

export {
  SET_TAB,
  setTab
};
